import React from 'react'
import AppleLogin from 'react-apple-login'
import { observer } from 'mobx-react-lite'
import { cacheService } from '../../../services/cacheService'
import apiService from '../../../services/apiServices'

import { useNavigateTo } from '../../../helpers/navigateTo'

import appleLogo from '../../assets/icons/apple.svg'

import style from '../signin.module.css'
import {clearCache} from "../../../helpers/clearCache";

const LoginWithApple = observer(() => {
    const APPLECLIENTID = 'io.pandamr.space'
    const { navigateTo } = useNavigateTo()

    const setAppleLogin = async (res) => {
        try {
            const response = await responseApple(res)
            const { token, public_id } = response.data.data
            const alternateGuest = cacheService.get('AlternateGuest')
            clearCache();
            cacheService.set('Id', public_id)
            cacheService.set('Authorization', `Token ${token}`)
            if (!!alternateGuest) {
                navigateTo({ pathname: `/dashboard/${alternateGuest}` }, { replace: true })
                cacheService.set('AlternateGuest', '')
            } else {
                navigateTo({ pathname: '/dashboard', search: '?%signIn' })
            }

        } catch (e) {
            console.warn('ERROR: ', e.message)
        }
    }

    const responseApple = (response) => apiService.setAppleLoginToken({
        'auth_token': response.authorization.id_token,
    })

    return (
        <AppleLogin
            clientId={APPLECLIENTID}
            redirectURI={window.location.origin + '/dashboard'}
            usePopup={true}
            callback={response => setAppleLogin(response)}
            scope="email name"
            render={renderProps => (  //Custom Apple Sign in Button
                <button
                    onClick={renderProps.onClick}
                    className={style.social_btn}
                >
                    <img className={style.social_img} src={appleLogo} alt="apple" />
                </button>
            )}
        />
    )
})

export default LoginWithApple